/**
 * @module experience/shop/cart-review
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

export const VALIDATE_MODAL_CONSTANTS = {
  IMEI: 'imei',
  SIM: 'sim',
  SKU: 'sku',
  USKU: 'usku',
  SERIAL_NUMBER: 'serialNumber',
  LINEITEMS: 'lineItems',
  NONLINEITEMS: 'nonLineItems',
  NON_LINE_DEVICES_ITEMS: 'nonLineDeviceItems',
  ACCESSORY: 'accessory',
  VALIDATE: 'validate',
  UPC: 'upc',
  CONTROLS: 'controls',
  MODULE_NAME: 'CartReviewModule',
  COMPONENT_NAME: 'ValidateModalComponent',
  WARNING: 'unexpected itemType',
  SIM_CARD: 'simcard',
  SELLABLECODE: 'SR305',
  NON_SELLABLE_HARDSTOP: 'SR304',
  NON_SELLABLE_OVERRIDE: 'SR504',
  SELLABLE_NOT_IN_INVENTORY: 'SR515',
  AVAILABLE: 'AVAILABLE',
  SIMKIT: 'simKit',
  DEVICE: 'device',
  LINED_DEVICE: 'linedDevice',
  SIM_SERIALIZATION_ON: 'ON',
  ENABLE: 'ENABLE',
  REPLACEMENT_ITEM: 'replacementItem',
  ACTIVITY_TIMEOUT: 'Backend Activity Timeout',
  CART_LINES: 'lines',
  CART_DEVICES: 'devices',
  BLOCKED: 'BLOCKED',
  AGING: 'AGING',
  INUSE: 'INUSE',
  RESERVED: 'RESERVED',
  VALID: 'VALID',
  OVERRIDE: 'OVERRIDE',
  INVALID: 'INVALID',
  VALIDATE_DEVICE: 'Validate Device',
  LINE_ITEM: 'lineItem',
  ESIM: 'ESIM',
  PSIM: 'PSIM',
  SUPPORTED_EID: 'Y',
};

export const MAX_ALLOWED_LINES = 20;

export const INPUT_DETECTION_DELAY = 1000;

export enum PricingOptionsEnum {
  FullPrice,
  EIP,
}

export const RUN_CREDIT_RADIO_BUTTONS = {
  RUN_CREDIT_CHECK: 'runCreditCheck',
  DO_NOT_RUN_CREDIT_CHECK: 'doNotRunCreditCheck',
};

export const CHECKOUT_MODAL_OPTIONS_CONSTANTS = {
  CONTINUE: 'Continue',
  CANCEL: 'Cancel',
};

export const CART_REVIEW_CONST = {
  ANON: 'ANON',
  QUANTITY: 'quantity',
  EXCHANGE: 'EXCHANGE',
  WARRANTY: 'WARRANTY',
  ADD: 'ADD',
  RETAIN: 'RETAIN',
  REMOVE: 'REMOVE',
  RETURN: 'RETURN',
  ADDON: 'ADDON',
  ONDEMAND: 'ONDEMAND',
  SIMCARD: 'SimCard',
  REVIEW_ORDER: 'Review your order',
  ACCOUNT_SETUP: 'Account Setup',
  LINE_SETUP: 'Line Setup',
  SHOPPING_CART: 'Your shopping cart',
  MRC_INCREASED: 'increased',
  MRC_DECREASED: 'decreased',
  VOUCHER: 'VOUCHER',
  ORDER_REASON_REMORSE: 'REMORSE',
  ERROR_STATUS_101: '101',
  BACKORDER: 'BACKORDER',
  NOT_AVAILABLE: 'NOT AVAILABLE',
  PAYMENT: 'Payment',
  CART_CHECKOUT: 'Cart Checked Out',
  RECEIVED: 'RECEIVED',
  SUBTOTAL_MESSAGE: 'Taxes and shipping will be calculated when you check out',
  SHIPPING: 'Shipping',
  LEGAL_TEXT: 'legal-text',
  BACKORDERED: 'BACKORDERED',
  ENABLE: 'ENABLE',
  FRAUD_REVIEW: 'Fraud Review',
  REVIEW_ORDER_PAGE_TITLE: 'Review your order',
  PAYMENT_PAGE_TITLE: 'Payment options',
  CART_REVIEW: 'CartReview',
  ORDER_REVIEW: 'OrderReview',
  VALID: 'valid',
  OVERRIDE: 'override',
  VESTA_ERROR_CODES: 'VESTA_',
  ERROR_CODE: 'ORDER-1003',
  INVENTORY_FAIL: 'InventoryCheckFailed',
  CHECKED_OUT: 'checkedout',
  LINE_INCOMPLETE: 'Before you checkout, you will need to: Add a device to each line',
  ACCESSORY_ONLY_CART: 'accessory_only_cart',
  OTHER_ITEMS_CART: 'other_items_cart',
  EMPTY_CART: 'empty_cart',
  ZERO: '0',
  FIVE: '5',
  FAMILY_ID: 't-mobile-prepaid-plans',
  ONE: '1',
};

export const ROUTES = {
  ACCOUNT_SETUP: '/cart/account-setup',
  LINE_SETUP: '/cart/line-setup',
  ACCOUNT_LINE_SETUP: '/account-line-setup',
  PRODUCT_SELECTOR: '/product-selector/setup',
  PRODUCT_SELECTOR_ACTIVATE: '/product-selector/activate',
  ORDER_REVIEW: '/cart/order-review',
  ORDER_RETURN: '/cart/return/payment',
  CART_AUTHENTICATE: '/cart/cart-authentication',
  PAYMENT: '/order/payment',
  COMMUNICATION: '/credit-check/communications',
  BROWSE_PLANS_PHONE: '/browse-plans-phone',
  PRODUCT_DETAILS: '/product-details/',
  SHIPPING: '/cart/shipping',
  CART_REVIEW: '/cart/review',
  BROWSE_ACCESSORY_CATEGORY: '/browse-accessories/accessoryCategory',
  BROWSE_DEVICES: '/browse-phones',
};

export const CART_MODULE_NAME = 'CartModule';
export const INSTORE_CART_MODULE_NAME = 'InstoreCartModule';
export const ONLINE_CART_MODULE_NAME = 'OnlineCartModule';
export const INSTORE_PAYMENT_MODULE_NAME = 'InstorePaymentModule';
export const ORDER_CONFIRMATION_MODULE_NAME = 'OrderConfirmationModule';
